import { render } from "./TableCellCollapse.vue?vue&type=template&id=64518613"
import script from "./TableCellCollapse.vue?vue&type=script&lang=js"
export * from "./TableCellCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__